import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';
import { hash } from 'rsvp';

import { keywordsForHelpTopic } from 'rise-ui/config/help-topic-keywords.js';
import strings from 'rise-ui/config/strings.js';
import { breadcrumb, breadcrumbResolve, breadcrumbResolved } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';
import { htmlToText } from 'rise-ui/utils/html.js';
import { queryParams } from 'rise-ui/utils/link-to.js';
import { getFirstParagraph } from 'rise-ui/utils/string.js';

@scrollRoot
export default class HelpPageRoute extends Route {
  @service dynamicNode;
  @service helpSearch;
  @service keywords;
  @service router;
  @service store;

  setHeadTags(model) {
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: getFirstParagraph(htmlToText(
            this.dynamicNode.compile(model.helpPage.bodyProcessed)().html
          )),
        },
      },
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords.keywords(
            true,
            strings['data-keywords'],
            keywordsForHelpTopic(model.helpPage.topic),
          ),
        },
      },
    ];
  }

  @breadcrumb crumb = 'Help Page';

  model({ help_page_id }) {
    return hash({
      helpPage: this.store.findRecord('help-page', help_page_id),
    });
  }

  @breadcrumbResolve modelCrumbResolve(model) {
    return Promise.all([ model.helpPage, this.helpSearch.topics ]);
  }
  @breadcrumbResolved modelCrumb(model) {
    const topic = model.helpPage.topic;
    return [
      {
        text: this.helpSearch.topics[topic],
        params: [ 'help.search', queryParams({ search: undefined, topic }) ],
      },
      model.helpPage.get('title'),
    ];
  }
}
